import { IApiError } from '@frontend/request';

import { IAPIControllerCallbacks } from '@aqx-core/common/api/types';

import signalAPI from '../api';
import {
  IHideSignalCategoriesParams,
  ISignal,
  ISignalCategoriesResult,
  ISignalDetails,
  ISignalDetailsParams
} from '../model';

class SignalAPIController {
  private signalsAC?: AbortController;
  private categoriesAC?: AbortController;
  private favouritesAC?: AbortController;
  private detailsAC?: AbortController;

  public getAllSignals = async (callbacks: IAPIControllerCallbacks<ISignal[]>) => {
    try {
      this.signalsAC?.abort();
      this.signalsAC = new AbortController();

      const { result } = await signalAPI.all();
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public hideSignalCategories = async (
    params: IHideSignalCategoriesParams,
    callbacks: IAPIControllerCallbacks<void>
  ) => {
    try {
      await signalAPI.hide(params);
      callbacks.onSuccess();
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public getSignalCategories = async (callbacks: IAPIControllerCallbacks<ISignalCategoriesResult>) => {
    try {
      this.categoriesAC?.abort();
      this.categoriesAC = new AbortController();

      const { result } = await signalAPI.categories();
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public getFavouriteSignals = async (callbacks: IAPIControllerCallbacks<ISignal[]>) => {
    try {
      this.favouritesAC?.abort();
      this.favouritesAC = new AbortController();

      const { result } = await signalAPI.favourites();
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public getSignalDetails = async (
    params: ISignalDetailsParams,
    callbacks: IAPIControllerCallbacks<ISignalDetails>
  ) => {
    try {
      this.detailsAC?.abort();
      this.detailsAC = new AbortController();

      const { result } = await signalAPI.getDetails(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public cleanup = () => {
    this.signalsAC?.abort();
    this.categoriesAC?.abort();
    this.favouritesAC?.abort();
    this.detailsAC?.abort();
  };
}

export const signalAPIController = new SignalAPIController();
export default signalAPIController;
